import { getKey, setKey, removeKey, repeat, getIp, initGId, copyToClipbord, judgeClientSystem, isWxBroswer, isWxMiniprogram, isBaiduMiniprogram } from './utils'
import { generateUUID } from '../services/stat'
import { Base64 } from 'js-base64'
import axios from './axios'
import { dateUtils } from './date-utils'
import coordtransform from 'coordtransform'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import qs from 'qs'
import { mapActions } from 'vuex'
import wx from 'weixin-webview-jssdk'


/**
 * 金钱格式化
 * 每三位一个逗号 保留2位小数
 * @param num
 * @returns {string}
 */
function formatMoney (num) {
  try {
    return num.toFixed(2).replace(/\B(?=(\d{3})+\D)/g, ',')
  } catch (err) {
    return '0.00'
  }
}

/**
 * 数字格式化
 * 每三位一个逗号 不保留小数位
 * @param num
 * @returns {string}
 */
function formatAmount (num) {
  try {
    return num.toFixed(0).replace(/\B(?=(\d{3})+(\D|$))/g, ',')
  } catch (err) {
    return '0.00'
  }
}

/**
 * 脱敏
 * @param str
 * @param starOffset
 * @param endOffset
 * @returns {string}
 */
function stringMosaic (str, starOffset, endOffset) {
  if (!str) return ''
  str = String(str)
  const mosaic = repeat('*', str.length - starOffset - endOffset)
  const exp = new RegExp(`^(.{${starOffset}}).*(.{${endOffset}})$`)
  return str.replace(exp, (origin, $1, $2) => {
    return `${$1}${mosaic}${$2}`
  })
}

/**
 * 日期格式化
 * @param fmt 默认 年/月/日
 * @param dateString
 * @returns {string}
 */
const formatDate = (dateString, fmt = 'YYYY/MM/DD') => {
  return dateUtils.format(dateString, fmt)
}
// 日期的后一天
const formatDateNextDay = (dateString, fmt = 'YYYY/MM/DD') => {
  return dateUtils.nextDates(dateString, 0, fmt)
}

const isEmptyString = (str) => {
  return !str
}

/**
 * 获取地理信息
 * 返回一个数组 [纬度，经度]
 * @returns {Promise<any>}
 */
const getGeolocation = (sensors) => {
  return new Promise(resolve => {
    sensors && sensors.track('getGeolocationFromInPormise')
    setTimeout(() => {
      sensors && sensors.track('getGeolocationFromSetTimeout')
      resolve(false)
    }, 3000)
    try {
      // eslint-disable-next-line
      navigator.geolocation.getCurrentPosition(res => {
        if (res.coords) {
          const { longitude, latitude } = res.coords
          console.log('原始定位：', longitude, latitude)
          sensors && sensors.track('geolocationInit', {
            positons: { longitude, latitude }
          })
          try {
            const gcjResult = coordtransform.wgs84togcj02(longitude, latitude)
            const result = coordtransform.gcj02tobd09(gcjResult[0], gcjResult[1])
            console.log('百度定位：', result)
            resolve(result)
          } catch (error) {
            sensors && sensors.track('geolocationConvertFail', {
              positons: { longitude, latitude }
            })
            console.log('获取定位失败', error)
            resolve(false)
          }
        } else {
          resolve(false)
        }
      }, err => {
        console.log('获取定位失败', err)
        sensors && sensors.track('getGeolocationFail', { errorMsg: err.message })
        resolve(false)
      }, {
        enableHighAccuracy: true,
        timeout: 3000,
        maximumAge: 0
      })
    } catch (exp) {
      resolve(false)
    }
  })
}

const commonMethods = {
  data () {
    return {
      downloadVisible: false,
      webclipPopVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      copyPopVisible: false,
      jumpPosition: '',
      wxmpType: '',
      packageId: '',
      packageKey: '',
      appUrl: '',
      uaIsIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      isWechat: navigator.userAgent.toLocaleLowerCase().includes('micromessenger')
    }
  },
  computed: {
    IsIosDownload () {
      return this.jumpPosition === 'APP_PACKAGE'
    },
    isIosWebClip () {
      return this.jumpPosition === 'WebClip'
    },
    isWxmpQrCode () {
      return this.jumpPosition === 'WXMP' && this.wxmpType === 'WXMP_QR_CODE'
    },
    isWxmpLink () {
      return this.jumpPosition === 'WXMP' && this.wxmpType === 'WXMP_LINK'
    },
    // 是否展示弹窗蒙层（只在支付宝、和IOS中的微信浏览器）
    isShowMask () {
      const ua = navigator.userAgent
      const isAli = !!ua.toLowerCase().match(/AliApp/i)
      const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isIpad = ua.indexOf('iPad') > -1
      if (isAli || ((isiOS || isIpad) && isWxBroswer())) {
        return true
      }
    },
    // 是否安卓手机
    isAndroid () {
      return judgeClientSystem() === 'Android'
    },
    isQlc () {
      const channel = this.$route.query.channel || getKey('channel')
      return channel === 'qlc'
    },
    isIosSafari () {
      const isIosDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      const isInSafari = /Safari/i.test(navigator.userAgent)
      const isAppleWebKit = /AppleWebKit/i.test(navigator.userAgent)
      return isIosDevice && isAppleWebKit && isInSafari
    }
  },
  methods: {
    /**
     * 返回首页
     * @param {boolean} [needsBackToNativeHome=false] 是否需要返回到原生首页 (只在APP中有效）
     */
    backHome (needsBackToNativeHome = false) {
      if (isWxMiniprogram()) {
        // 微信小程序
        wx.miniProgram.postMessage({ data: { eventType: 'BACK_HOME', eventId: '', url: '', value: null } })
        wx.miniProgram.navigateBack()
      } else if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        if (needsBackToNativeHome) {
          jsBridge('navigateTo', { path: 'home', exitCurrent: true })
        } else {
          jsBridge('exit')
        }
      } else {
        this.$router.push('/')
      }
    },
    // 对于嵌入到第三方 有时候获取不到query
    getParams () {
      if (!window.location.search) {
        return {}
      } else {
        const _search = window.location.search.replace('?', '')
        const params = qs.parse(_search) || {}
        const _query = this.$route.query
        if (_query && Object.keys(_query).length) {
          return _query
        }
        return params
      }
    },
    back (exit) {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS' && (this.isFirstAndApp || exit)) {
        jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 针对第三方API导流 收集数据
     */
    async sendDataForThird () {
      let appData = {}
      console.log(hasNativeMethod('getApiDeviceInfo'))
      if (hasNativeMethod('getApiDeviceInfo')) {
        const { data } = await jsBridge('getApiDeviceInfo')
        console.log(data)
        appData = data
      }

      // 获取GID
      const deviceId = getKey('uuid')

      // 获取是安卓还是ios
      const appVersionType = judgeClientSystem() === 'IOS' ? 'iphone' : 'android'

      // 系统时区
      const date = new Date()
      const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      // 系统时间
      const systemTime = formatDate(date, 'hh:mm:ss')

      // 系统日期
      const systemDate = formatDate(date, 'YYYY-MM-DD')

      // 过滤安卓传过来的空对象
      const newData = {}
      Object.keys(appData || {}).map(key => {
        if (appData[key]) {
          newData[key] = appData[key]
        }
      })
      const params = Object.assign({}, { deviceId, appVersionType, systemTimezone, systemDate, systemTime }, { ...newData })
      return axios.post('/diversion/v1/device-info', params)
    },
    // 间隔日判断
    isIntervalDay (type, days) {
      const lastShowTime = getKey(type)
      let lastShowDate
      if (lastShowTime) {
        lastShowDate = new Date(lastShowTime)
        lastShowDate.setHours(0, 0, 0, 0)
        lastShowDate.setDate(lastShowDate.getDate() + days)
      } else {
        return true
      }
      return new Date() > lastShowDate
    },
    isIntervalDayBySession (type, days) {
      const lastShowTime = sessionStorage.getItem(type)
      let lastShowDate
      if (lastShowTime) {
        lastShowDate = new Date(lastShowTime)
        lastShowDate.setHours(0, 0, 0, 0)
        lastShowDate.setDate(lastShowDate.getDate() + days)
      } else {
        return true
      }
      return new Date() > lastShowDate
    },
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('a')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.href = schema
        body.appendChild(node)
        node.click()
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    // 增对下载流程做了统一的优化 下载方式调用 @/view/landing/jumpMixins.js 的 generalDownloadAction方法
    async  getAndradoidUrl () {
      const userInfo = getKey('userInfo')
      const userId = userInfo ? userInfo.userId : ''
      // const channel = this.$route.query.channel || getKey('channel') || 'official'
      return new Promise(async (resolve, reject) => {
        const { data } = await axios.get('/redirect/app/download-url', {
          userId,
          uuid: generateUUID()
        })
        if (data && data.success) {
          resolve(data.data)
        } else {
          resolve('https://download.ndmicro.com/apk/release/tmd_Official_release.apk')
        }
      })
    },
    async downloadApp () {
      const channel = this.$route.query.channel || getKey('channel') || 'official'
      this.$report({
        id: 10063,
        args: {
          channel: channel
        }
      })
      const userInfo = getKey('userInfo')
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        // 是微信小程序 || 百度小程序
        if (window.location.search) {
          copyToClipbord(`${window.location.href}&token=${userInfo.token}`)
        } else {
          copyToClipbord(`${window.location.href}?token=${userInfo.token}`)
        }
        this.$message('复制成功', 2000)
      } else {
        // 设备检测 IOS 去获取下载方式
        if (judgeClientSystem() === 'IOS') {
          if (!this.jumpPosition) {
            await this.getAppInfo()
          }

          // 如果获取到了IOS下载的最新地址 直接去appstore打开
          if (this.IsIosDownload) {
            window.location.href = this.appUrl
            return
          }
          if (this.isIosWebClip) {
            this.$nextTick(() => {
              setTimeout(() => {
                if (this.isIosSafari) {
                  this.webclipPopVisible = true
                } else {
                  this.copyPopVisible = true
                }
              }, 300)
            })
            return
          }
          if (this.isWxmpQrCode) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.iosWxmpQRCodeDialogVisible = true
              }, 300)
            })
            return
          }
          if (this.isWxmpLink) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.iosWxmpLinkDialogVisible = true
              }, 300)
            })
            return
          }
          // url参数上带T 自动跳首页
          if (this.$route.query.home === 'T') {
            return this.$router.replace('/')
          }
          // 不管是否是要下载 都触发弹出关注公众号
          this.$nextTick(() => {
            setTimeout(() => {
              this.downloadVisible = true
              this.$sensors.track('PopupDisplay', { msg_name: '公众号引导弹窗', caseid: 'we_public' })
            }, 300)
          })
        } else {
          let androidUrl = await this.getAndradoidUrl() // 安卓下载链接
          const userAgent = navigator.userAgent
          const isAndroid =
            userAgent.indexOf('Android') > -1 ||
            userAgent.indexOf('Adr') > -1 // android终端
          const isTieba = !!userAgent.toLowerCase().match(/tieba/i)
          const isWeiXin = !!userAgent.toLowerCase().match(/MicroMessenger/i)
          const isWeiBo = !!userAgent.toLowerCase().match(/WeiBo/i)
          const isQQ = !!userAgent.match(/\sQQ/)
          if (isAndroid) {
            // 安卓
            if (isWeiXin || isWeiBo || isQQ || isTieba) {
              // 第三方应用打开 腾讯应用宝
              androidUrl =
                'https://sj.qq.com/myapp/detail.htm?apkName=com.nd.tmd&info=EB81D9CE029816C8ED6116B67387E055'
              window.location.href = androidUrl
            } else {
              // 浏览器打开
              window.location = androidUrl
            }
          }
        }
      }
    },
    // 获取ios渠道与id
    ...mapActions('user', ['getChannelJumpX']),
    async getAppInfo (point = false) {
      if (judgeClientSystem() === 'IOS') {
        const { success, data } = await this.getChannelJumpX()
        if (success) {
          const { jumpPosition, packageId, packageKey, wxMiniProgramType } = data
          this.jumpPosition = jumpPosition
          this.wxmpType = wxMiniProgramType
          // 针对检测数据的埋点
          if (point) {
            const params = {
              page_status: jumpPosition
            }
            if (jumpPosition === 'WXMP') {
              params.additinal_status = wxMiniProgramType
            }
            if (jumpPosition === 'APP_PACKAGE') {
              params.additinal_status = packageKey
            }
            this.$sensors.track('parameters_report', { ...params })
          }
          if (jumpPosition === 'APP_PACKAGE') {
            this.packageId = packageId
            this.packageKey = packageKey
            const appUrl = ['H5-ppd', 'H5-ppd1', 'H5-ppd2'].includes(this.$route.query.channel) ? 'https://itunes.apple.com/cn/app/id' : 'itms-appss://apps.apple.com/cn/app/id'
            this.appUrl = appUrl + packageId
          }
        }
      }
    },

    async copyUrlAndToast () {
      const channel = this.$route.query.channel || getKey('channel') || 'official'
      this.$report({
        id: 10063,
        args: {
          channel
        }
      })
      const userAgent = navigator.userAgent
      const androidUrl = await this.getAndradoidUrl() // 安卓下载链接
      // let androidUrl = 'https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/apk/release/tmd_Offical_release.apk'
      const isAndroid =
        userAgent.indexOf('Android') > -1 ||
        userAgent.indexOf('Adr') > -1 // android终端
      const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isIpad = userAgent.indexOf('iPad') > -1
      if (isAndroid) {
        copyToClipbord(androidUrl)
      } else if (isiOS || isIpad) {
        if (!this.jumpPosition) {
          await this.getAppInfo()
        }
        copyToClipbord(this.appUrl)
      }
      this.$message('下载链接已复制，请到浏览器中打开', 8000)
    },
    nextNodeCommon (item) {
      const { nextStep = '', relationId, type } = item
      switch (nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr' }
        case 'INFO':
        case 'CREDIT':
          return { h5: '/authentication/base', native: 'basic_info' }
        case 'CREDIT_REVIEW':
        case 'CREDIT_LOCKED':
          return {
            h5: `/authentication/result?applyNo=${relationId}`
          }
        case 'CREDIT_SUCCESS':
          return { h5: '/withdraw/index', native: 'withdraw' }
        case 'TIMEOUT':
          return { h5: '/quan/history' }
        case 'LOAN_AUDIT':
        case 'LOAN_LOCKED':
        case 'LOCKED':
        case 'LOANING':
        case 'LOAN_REVIEW':
        case 'LOAN_WAIT_VIP':
          return {
            h5: `/withdraw/result?loanApplyNo=${relationId}`
          }
        case 'LOAN':
          return { h5: '/withdraw/index', native: 'withdraw' }
        case 'LOAN_PASSED':
        case 'REPAY':
          return { h5: '/repayment', native: 'repayment' }
        case 'REPAYING':
          return { h5: `/repayment/result?repayId=${relationId}&type=${type}` }
        default:
          return { h5: '/authentication/id', native: 'ocr' }
      }
    },
    getDevice () {
      const deviceInfo = {
        terminal: getKey('terminal') || 'H5',
        appVersion: getKey('appVersion'),
        uuid: generateUUID()
      }
      return Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
    },
    formatMoney (num) {
      if (!num) return ''
      return formatMoney(num)
    },
    formatAmount (num) {
      if (!num) return ''
      return formatAmount(num)
    },
    // 日期格式化
    formatDate (dateString, fmt) {
      if (!dateString) return ''
      return formatDate(dateString, fmt)
    },
    formatDateNextDay (dateString, fmt) {
      if (!dateString) return ''
      return formatDateNextDay(dateString, fmt)
    },
    isEmptyString (str) {
      return isEmptyString(str)
    },
    isNotEmptyString (str) {
      return !isEmptyString(str)
    },
    // 字符串安全转换，如果为null或者undefined，返回空字符串
    safeString (str) {
      return isEmptyString(str) ? '' : str
    },
    formatMobile (mobile) {
      if (!mobile) return ''
      return stringMosaic(mobile, 3, 4)
    },
    getGeolocation () {
      return getGeolocation(this.$sensors)
    },
    async riskReport (node, userInfo = {}) {
      // 上报设备信息
      let ip, geolocation, gid, channel, _userInfo
      channel = getKey('channel') || 'Official'
      _userInfo = getKey('userInfo') || {}

      try {
        this.$indicator()
        // 针对预览提现节点 NODE===3的时候做埋点
        node === 3 && this.$sensors.track('initGId')
        gid = await initGId()
        node === 3 && this.$sensors.track('getGeolocation')
        geolocation = await this.getGeolocation()
        node === 3 && this.$sensors.track('getIp')
        ip = await getIp()
      } catch (exp) {
        console.log('获取信息错误')
        console.log(`IP:${ip}`)
        console.log(`GPS:${geolocation}`)
        console.log(`GID:${gid}`)
        this.$sensors.track('riskReportGetInfoError', { msg: exp.message })
      } finally {
        this.$indicator.close()
        const eventMapping = {
          1: 'login',
          2: 'lend',
          3: 'cash'
        }
        if (window.hasOwnProperty('BRCore')) BRCore.tools.Tools.sendCollect({ 'event': eventMapping[node] })
        let latitude = ''
        let longitude = ''
        if (getKey('channel') !== 'API-XHQB') {
          latitude = geolocation ? geolocation[1] : ''
          longitude = geolocation ? geolocation[0] : ''
        }
        const _locationInfo = getKey('locationInfo')
        if (getKey('terminal') === 'IOS' && _locationInfo) {
          if (_locationInfo) {
            latitude = _locationInfo.latitude
            longitude = _locationInfo.longitude
          }
        }

        let platform = ''
        const ua = window.navigator.userAgent
        if (ua.includes('NDMicroApp')) {
          platform = 'TMQB_H5'
        } else if (ua.includes('iOS-LxhApp')) {
          platform = 'iOS-H5-LXH'
        } else {
          platform = 'H5'
        }
        const params = {
          traffic: channel,
          node,
          phoneNumber: userInfo.mobile || _userInfo.mobile || '',
          userIdNumber: userInfo.idCard || _userInfo.idCard || '',
          platform: platform,
          product: 'TMD',
          gid: (typeof gid === 'string') ? gid : null,
          data: {
            latitude,
            longitude,
            ip,
            channel
          }
        }
        this.$sensors.track('riskReport', { params: JSON.stringify(params) })
        try {
          await axios.post('/pushdata/device-info', params, { notNeedBaseURL: true })
        } catch (error) {
          this.$sensors.track('riskReportError', { msg: error.message })
        }
      }
    },
    // 跳转至尊王卡相关页面
    jumpToKingCardPage () {
      const origin = process.env.VUE_APP_PAYURL
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const data = `gid=${gid}&token=${token}&channel=${channel}`
      window.location.href = `${origin}/vip/skc?${data}&refurl=${window.location.origin}`
      return false
    },
    // 在安卓里面直接关闭，其他不做任何处理
    handleExit () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      }
    },
    // 跳转客服页面
    handleJumpService () {
      this.$router.push('/service')
    },
    // IOS中落地页跳转（根据配置开关判断跳转）
    handleLandingJump (type, them) {
      if (['APP_PACKAGE', 'OA', 'WebClip', 'WXMP'].includes(type)) {
        if (this.channels.includes(this.channel)) {
          const token = getKey('userInfo', 'token') || ''
          window.location.href = `${this.landingTestChannelUrl}/landing/${them}/result?channel=${this.channel}&token=${token}`
          return
        }
        return this.$router.push(`/landing/${them}/result?channel=${this.channel}`)
      } else if (type === 'H5') {
        return this.$router.push('/')
      }
    },
    /*
    * 判断对应会员类型的状态
    @param memberType: MemberGoodsGroupCd.OLD/ENJOY/LIGHT_ENJOY/SVIP/PRIVILEGE/UNLIMITED/GVIP/GPVIP/XMVIP_API
    @param memberGoodsGroupCd: 当前会员类型，通常由接口返回
    @param memberStatus: 会员状态，通常由接口返回

    @return memberType对应的状态，isValid-有效；isFROZEN-冻结，ISEXPIRED-过期
    !hahah
    ?hahaha
    @heihei
    */
    getMemberStatus (memberType, memberGoodsGroupCd, memberStatus) {
      const isMemberTheSame = memberType === memberGoodsGroupCd
      const isValid = isMemberTheSame && memberStatus === 'NORMAL'
      const isFrozen = isMemberTheSame && memberStatus === 'FROZEN'
      const isExpired = isMemberTheSame && memberStatus === 'EXPIRED'
      return {
        isValid,
        isFrozen,
        isExpired
      }
    }
  },

  filters: {
    currency (num) {
      return formatMoney(num)
    },
    toFixed (value) {
      return Math.floor(value / 10000)
    },
    amount (num) {
      return formatAmount(num)
    },

    mobile (mobile) {
      return stringMosaic(mobile, 3, 4)
    },

    date (dateString, fmt) {
      return formatDate(dateString, fmt)
    },

    platform (value) {
      const mapping = {
        YZD: '聚美颜值贷',
        LFQ: '领分期'
      }
      return mapping[value]
    }
  }
}

export default {
  install (Vue) {
    Vue.prototype.$storage = {
      set: setKey,
      get: getKey,
      remove: removeKey
    }
    Vue.mixin(commonMethods)
  }
}